import React, { Component } from 'react';

import { TextField } from 'react-md';

export default class NameSlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.editText = this.editText.bind(this);
    }

    editText(func, text) {
        if (text.length <= 40) {
            func(text);
        }
    }

    render() {

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        let cardHeight = this.props.position === this.props.slideNumber ? 21 : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                <div className="gc-hello-name-container">
                    <div className="hello-hello">{"HELLO"}</div>
                    <div className="hello-sub">{"The name of my contest is..."}</div>
                    <div className="hello-name-container">
                        <TextField
                            id="goal-name-textfield"
                            placeholder={"Contest Name"}
                            className={"gc-text-input name"}
                            value={this.props.name}
                            onChange={this.editText.bind(null, this.props.changeName)}
                        />
                    </div>
                </div>
                <div className={"gc-question description"}>
                    {"And I would describe my contest as..."}
                </div>
                <TextField
                    id="goal-description-textfield"
                    placeholder={"Description"}
                    className={"gc-text-input description"}
                    value={this.props.description}
                    onChange={this.editText.bind(null, this.props.changeDescription)}
                />
            </div>
        );
    }
}